// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"655e3cca","453":"daf98a40","455":"52500fae","457":"86fa94bf","842":"2724f72a","851":"00ce153f","977":"97abe85f"}[chunkId] + ".chunk.js";
};